export function initCandidateButtons(root = document) {
    const candidateCodes = window.candidateCodes || [];

    if (!candidateCodes.length) return;

    const selectors = ['.e-btn6', '.e-btn--arrow-candidate'];

    root.querySelectorAll(selectors.join(',')).forEach(btn => {
        if (candidateCodes.includes(btn.dataset.code)) {
            btn.dataset.state = 'disabled';
            btn.classList.add('disabled');
        }
    });
}
